"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonContainer = exports.StyledButtonGroupContainer = exports.StyledButtonGroupWrapper = exports.StyledSubHeaderContainer = exports.StyledHeaderContainer = exports.StyledZipContainerGroup = exports.ModalZipWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const helpers_1 = require("../helpers");
exports.ModalZipWrapper = components_core_1.styled.div `
  position: fixed;
  z-index: 999;
`;
exports.StyledZipContainerGroup = components_core_1.styled.div `
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 20px;
  max-width: 370px;

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    max-width: 470px;
  }
`;
exports.StyledHeaderContainer = components_core_1.styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;

  & > svg {
    margin-right: 14px;
    margin-top: -8px;
    color: #001e50;
  }

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    margin-bottom: 24px;
  }
`;
exports.StyledSubHeaderContainer = components_core_1.styled.div `
  width: 100%;
  margin-bottom: 55px;

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    margin-bottom: 60px;
  }
`;
exports.StyledButtonGroupWrapper = components_core_1.styled.div `
  display: inline-table;
`;
exports.StyledButtonGroupContainer = components_core_1.styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 60px;
  font-size: 32px;

  & > :first-child {
    margin-bottom: 40px;
  }

  @media (min-width: ${helpers_1.Breakpoints.b560}px) {
    max-width: 405px;

    p {
      font-size: 24px;
    }
    input {
      font-size: 48px;
    }

    & > :first-child {
      button svg {
        width: 32px;
        height: 32px;
      }
    }
  }
`;
exports.StyledButtonContainer = components_core_1.styled.div `
  width: 150px;
`;
